import React from 'react';

import WorksheetStatusButton from 'notebook/worksheets/workspace/WorksheetStatusButton';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';

interface WorksheetStatusBadgeProps {
  name: string;
  disabled?: boolean;
  showWorksheetStatusDropdownButton: boolean;
  worksheetStatusBadgeTooltipText: string | null;
}

export default function WorksheetStatusBadge({
  name,
  disabled,
  showWorksheetStatusDropdownButton,
  worksheetStatusBadgeTooltipText,
}: WorksheetStatusBadgeProps): JSX.Element {
  return (
    <Tooltip text={worksheetStatusBadgeTooltipText} placement={FloatingPlacement.LEFT}>
      <WorksheetStatusButton
        name={name}
        disabled={disabled}
        isDropdown={!disabled && showWorksheetStatusDropdownButton}
      />
    </Tooltip>
  );
}
